module.exports = __webpack_public_path__ + "static/media/computer-classic.4a223c97.svg";